import { useState } from 'react';
import LabelModal from 'legacy-src/components/TeacherOrganize/components/Labels/LabelModal';
import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import { LABEL_MODES } from 'legacy-src/components/TeacherOrganize/utils/constants';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';

export default function useLabelModal({ masterSubject = '', router }) {
  const {
    labels,
    parents,
    isStudentVisible,
    actions: { createLabel, updateLabel },
  } = useTeacherOrganizeContext({ masterSubject });

  const { cleanActionParams } = useNavigation({
    router,
  });

  const [isCreateEditModalVisible, setCreateEditModalVisible] = useState(false);
  const [isShowVisibilityModal, setShowVisibilityModal] = useState(false);

  const [labelMode, setLabelMode] = useState(LABEL_MODES.create);

  const parentLabels = parents.map((parentId) => labels[parentId]);

  const labelCommonProps = {
    masterSubjectId: parseInt(masterSubject, 10),
    studentVisible: isStudentVisible,
  };

  const [label, setLabel] = useState(labelCommonProps);

  const onLabelNameChange = (_label) =>
    setLabel((prevLabel) => ({
      ...prevLabel,
      name: _label,
    }));

  const onParentIdChange = (_parentId) =>
    setLabel((prevLabel) => ({
      ...prevLabel,
      parentId: parseInt(_parentId, 10),
    }));

  const createNewLabel = (parentId = null) => {
    setLabelMode(LABEL_MODES.create);
    setCreateEditModalVisible(true);
    setLabel(labelCommonProps);
    if (parentId) {
      setLabel((prevLabel) => ({
        ...prevLabel,
        parentId,
      }));
    }
  };

  const editLabel = (labelToEdit) => {
    setLabelMode(LABEL_MODES.edit);
    setCreateEditModalVisible(true);
    setLabel(labelToEdit);
  };

  const onClose = () => {
    setCreateEditModalVisible(false);
    cleanActionParams();
  };

  const createEditModalProps = {
    onLabelNameChange,
    onParentIdChange,
    onCreate: createLabel,
    onUpdate: updateLabel,
    onClose,
    mode: labelMode,
    label,
    parentLabels,
    labels,
  };

  return {
    LabelModal,
    labelCommonProps,
    isStudentVisible,
    createNewLabel,
    editLabel,
    isCreateEditModalVisible,
    createEditModalProps,
    setShowVisibilityModal,
    isShowVisibilityModal,
  };
}
